<div class="order-edit-delivery container">
  <form [formGroup]="ccrForm">
    <div class="row">
      <eps-radio-group class="field col-12 col-sm-6" formControlName="type" [options]="orderTypes" readonly label="ORDERS.DELIVERY.LABELS.CHOOSE_TYPE" [labelWidth]="labelWidth">
      </eps-radio-group>
      <eps-label-body class="field col-12 col-sm-6" label="ORDERS.DELIVERY.LABELS.SHIPPING_CONDITION" readonly [labelWidth]="labelWidth">
        {{ccrForm.value.shippingCondition.name}}
      </eps-label-body>
      <ng-container>
        <ng-container *ngIf="showFrom()">
          <eps-label-body label="ORDERS.DELIVERY.LABELS.FROM" readonly [labelWidth]="labelWidth" class="field col-12 col-md-5 col-sm-6">
            {{ ccrForm.value.from?.name }}
          </eps-label-body>
          <div class="field col-1 hidden-xs hidden-sm" *ngIf="showTo() && resolutionOkForArrow">
            <app-arrow class="myarrow" [width]="60"></app-arrow>
          </div>
        </ng-container>
        <div class="field col-6 hidden-xs hidden-sm" *ngIf="!showTo()"></div>
        <eps-label-body label="ORDERS.DELIVERY.LABELS.TO" readonly [labelWidth]="labelWidth" class="field col-12 col-sm-6" *ngIf="showTo()">
          {{ ccrForm.value.to?.name }}
        </eps-label-body>
      </ng-container>


      <div class="hr"></div>

      <eps-label-body label="ORDERS.DELIVERY.LABELS.RECEIVER_REF" readonly [labelWidth]="labelWidth" class="field col-12 col-sm-6">
        {{ deliveryMethod?.customerReferenceNumber || ('ORDERS.DELIVERY.LABELS.NO_RECEIVER_REF' | translate) }}
      </eps-label-body>

      <eps-label-body label="ORDERS.DELIVERY.LABELS.TRANSPORTER" readonly [labelWidth]="labelWidth" *ngIf="ccrForm.value.shippingCondition?.id !== 'Z1'" class="field col-12 col-sm-6">
        {{ deliveryMethod?.transporter ? deliveryMethod?.transporter : ('ORDERS.DELIVERY.LABELS.NO_TRANSPORTER' | translate) }}
      </eps-label-body>

      <eps-label-body label="ORDERS.DELIVERY.LABELS.SENDER_REF" readonly [labelWidth]="labelWidth" class="field col-12 col-sm-6">
        {{ deliveryMethod?.senderReferenceNumber || ('ORDERS.DELIVERY.LABELS.NO_SENDER_REF' | translate) }}
      </eps-label-body>

      <eps-label-body label="ORDERS.DELIVERY.LABELS.PLATE" readonly [labelWidth]="labelWidth" class="field col-12 col-sm-6">
        {{ deliveryMethod?.licensePlate ? deliveryMethod?.licensePlate : ('ORDERS.DELIVERY.LABELS.NO_LICENCE_PLATE' | translate) }}
      </eps-label-body>
    </div>
  </form>
</div>
